import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 控制相关接口
 **********************************************************************************/
export default {
	/**
	 * 分页获取组播列表
	 */
	getLoraMulticastLimit: (pageIndex, pageSize, success, failure) => {
		Axios.post('/controlApi/getLoraMulticastLimit.do', {
			pageIndex,
			pageSize
		}, success, failure)
	},
	/**
	 * 通过通讯变量名，查询绑定的遥控操作组，联查device表的名字和applicationName
	 */
	getOperationGroupInfoByVariableName: (variableNames, success, failure) => {
		Axios.post('/controlApi/getOperationGroupInfoByVariableName.do', {
			variableNames
		}, success, failure)
	},
	/**
	 * 查询指定遥控组对应信息
	 */
	getRTValueForOperationGroup: (group, success, failure) => {
		Axios.post('/controlApi/getRTValueForOperationGroup.do', {
			group,
		}, success, failure)
	},
	/**
	 * 获取空调组播遥控操作组/操作 树
	 */
	getOperationGroupTree: (success, failure) => {
		Axios.post('/controlApi/getOperationGroupTree.do', {}, success, failure)
	},
	/**
	 * 批量遥控一批设备
	 */
	multipleControlSwitch: (deviceNos, apptype, endState, timeOut, success, failure) => {
		Axios.post('/controlApi/multipleControlSwitch.do', {
			deviceNos,
			apptype,
			endState,
			timeOut,
		}, success, failure)
	},
	/**
	 * 批量遥控一批设备
	 */
	batchControlAir: (deviceNos,apptype,timeOut,nameType,success,failure) => {
		Axios.post('/controlApi/batchControlAir.do', {
			deviceNos,
			apptype,
			timeOut,
			nameType
		}, success, failure)
	},
	/**
	 * 批量遥控一批设备
	 */
	multipleControlAir: (deviceNos, apptype, timeOut, setTemperature, runModel, windSpeed, windHorizontal,
		windVertical, success, failure) => {
		Axios.post('/controlApi/multipleControlAir.do', {
			deviceNos,
			apptype,
			timeOut,
			setTemperature,
			runModel,
			windSpeed,
			windHorizontal,
			windVertical,
		}, success, failure)
	},
	/**
	 * 批量设置空调权限
	 */
	multipleAirPowerSet: (deviceNos, apptype, timeOut, lowTemperature, highTemperature, runModels, windSpeeds,
		windHorizontal,
		windVertical, success, failure) => {
		Axios.post('/controlApi/multipleAirPowerSet.do', {
			deviceNos,
			apptype,
			timeOut,
			lowTemperature,
			highTemperature,
			runModels,
			windSpeeds,
			windHorizontal,
			windVertical
		}, success, failure)
	},
}
